import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    authenticated: Boolean,
    targetSelector: String
  }

  click() {
    if (this.authenticatedValue) {
      this.scrollToForm()
    }
  }

  scrollToForm() {
    const target = document.querySelector(this.targetSelectorValue)
    if (!target) return

    target.scrollIntoView({ behavior: "smooth", block: "start" })

    const focusable = target.querySelector("input, textarea, select, button")
    if (focusable) {
      target.addEventListener(
        "transitionend",
        () => {
          focusable.focus({ preventScroll: true })
        },
        { once: true }
      )

      setTimeout(() => {
        focusable.focus({ preventScroll: true })
      }, 500)
    }
  }
}
